// extracted by mini-css-extract-plugin
export default {"carousel":"sG-z"};